import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  static TEST_ADS = false;
  static ANDROID_BANNER = "ca-app-pub-5333696200240759/8906217539";
  static IOS_BANNER = "ca-app-pub-5333696200240759/8139930770";
  static ANDROID_REWARDED = "ca-app-pub-5333696200240759/1968988683";
  static IOS_REWARDED = "ca-app-pub-5333696200240759/5141946932";

  constructor(
    private toast: ToastController,
    private translate: TranslateService
  ) { }

  showTranslatedMsg(msg: string) {
    this.translate.get(msg).subscribe(res => {
      this.showMsg(res);
    });
  }

  async showMsg(msg: string) {
    const toast = await this.toast.create({
      message: msg,
      duration: 2000
    });
    return toast.present();
  }
}
